
import InnerPageTitle from '@/components/Shared/InnerPageTitle/index.vue'
import BlogImage from './BlogImage.vue'
import BlogTitle from './BlogTitle.vue'
import BlogContent from './BlogContent.vue'
import BlogTags from './BlogTags.vue'
import BlogIsParked from './BlogIsParked.vue'
import CommentList from '@/components/Comments/CommentList.vue'
import LeaveComment from '@/components/Comments/LeaveComment.vue'
import BookCategories from '../BookContent/BookCategories.vue'
import PopularProducts from '~/components/Home/PopularProducts.vue'
import BookMostPopularProducts from '../BookContent/BookMostPopularProducts.vue'
import ExamList from '~/components/ExamList/index.vue'
export default {
  components: {
    InnerPageTitle,
    BlogImage,
    BlogTitle,
    BlogContent,
    CommentList,
    LeaveComment,
    BookCategories,
    PopularProducts,
    BookMostPopularProducts,
    BlogTags,
    BlogIsParked,
    ExamList,
  },
  props: {
    product: {
      default: () => {},
    },
  },
}
